import { render, staticRenderFns } from "./ReturnAddress.vue?vue&type=template&id=484ea104&scoped=true"
import script from "./ReturnAddress.vue?vue&type=script&lang=js"
export * from "./ReturnAddress.vue?vue&type=script&lang=js"
import style0 from "./ReturnAddress.vue?vue&type=style&index=0&id=484ea104&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ea104",
  null
  
)

export default component.exports